<template>
  <div class="scan">
    <div class="companBtn" @click="companyCode">扫描机构二维码</div>
    <div class="companBtn" @click="macCode()">扫描手环二维码</div>
    <div class="companBtn" @click="watchCode()">扫描网关二维码</div>
    <div class="companyTk" v-if="companyTk">
      <div class="main">
        <img
          src="../../assets/tk-close.png"
          @click="closeTk()"
          alt=""
          srcset=""
        />
        <div class="title">查询网关列表</div>
        <div class="listsTitle">
          <span>设备编号</span>
          <span>设备状态</span>
          <span>安装位置</span>
        </div>
        <div class="lists">
          <div
            v-for="(item, index) in companyList"
            @click="
              gateway = item.code;
              gatewayTk = true;
              getInfo();
            "
            :key="index"
          >
            <span>{{ item.code }}</span>
            <i :style="item.status == 1 ? 'color:#67C23A' : ''">{{ item.status == 1 ? "在线" : "离线" }}</i>

            <span>{{ item.address }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="companyTk" v-if="gatewayTk">
      <div class="main">
        <img
          src="../../assets/tk-close.png"
          @click="gatewayTk = false"
          alt=""
          srcset=""
        />
        <div class="title">查询网关详情</div>
        <div class="info">
          <p>设备编号：{{ gatewayInfo.code }}</p>
          <p>设备状态：<span :style="gatewayInfo.status == 1 ? 'color:#67C23A' : ''">{{ gatewayInfo.status == 1 ? "在线" : "离线" }}</span></p>
        </div>
        <p class="h3" v-if="onlineHistoryList.length > 0">最近上/下线历史</p>
        <div class="listsTitle" v-if="onlineHistoryList.length > 0">
          <span>设备状态</span>
          <span>操作时间</span>
        </div>
        <div class="lists">
          <div v-for="(item, index) in onlineHistoryList" :key="index">
            <i>{{ item.status == 1 ? "上线" : "下线" }}</i>
            <span>{{ item.onlineTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="companyTk" v-if="macTk">
      <div class="main">
        <img
          src="../../assets/tk-close.png"
          @click="macTk=false;closeTk()"
          alt=""
          srcset=""
        />
        <div class="title">查询手环详情</div>
        <div class="info">
          <p>手环编号：{{ macNumber }}</p>
          <p>心率：{{ macInfo.hr }}</p>
          <p>最近上传时间：{{ macInfo.time }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import serivce from "@/utils/ajax";
export default {
  data() {
    return {
      companyList: [],
      companyTk: false,
      companyId: "",
      page: 1,
      gateway: "",
      gatewayTk: false,
      onlineHistoryList: [],
      gatewayInfo: {},
      macNumber: "",
      macInfo: {},
      macTk: false,
      timer: null,
    };
  },
  mounted() {
    // clearInterval(this.timer);
    this.appid = process.env.VUE_APP_BASE_APPID;
    const vm = this;
    let data = {};
    if (!window.localStorage.getItem("openId")) {
      this.code = this.getUrlCode().code;
      if (this.code) {
        serivce
          .get(`/api/lxUser/openid`, {
            code: this.code,
          })
          .then((res) => {
            if (res.status == 200) {
              let temp = JSON.parse(res.msg);
              data.access_token = temp.access_token;
              data.openid = temp.openid;
              localStorage.setItem("refresh_token", data.refresh_token);
              localStorage.setItem("access_token", data.access_token);
              localStorage.setItem("openId", data.openid);
              vm.openid = data.openid;
              vm.wxConfig();
            } else {
              this.$toast({
                type: "fail",
                message: "网络异常，获取微信信息失败，请重新扫码。",
                className: "failLong",
                duration: 4000,
              });
            }
          });
      } else {
        this.getCode();
      }
    } else {
      // 别的业务逻辑
      vm.wxConfig();
    }
    if(this.$route.query.cid){
      this.companyId = this.$route.query.cid
      this.getCompany()
    }
  },
  methods: {
    closeTk() {
      clearInterval(this.timer);
      // window.clearInterval(this.timer);
      this.timer = null;
      this.companyTk = false;
      this.macTk = false;
    },
    getCode() {
      var local = window.location.href;
      var appid = process.env.VUE_APP_BASE_APPID;
      var secret = process.env.VUE_APP_BASE_SECRET;
      // 截取code
      this.code = this.getUrlCode().code;
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    wxConfig() {
      serivce
        .get("/api/lxUser/wxconfig", {
          appid: this.appid,
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          let data = res.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.appid, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ["checkJsApi", "scanQRCode"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        });
    },
    getCompany() {
      serivce
        .get(
          `https://lingximind.com/mqtt/gateway/list?page=${this.page}&size=30&companyId=${this.companyId}`
        )
        .then((res) => {
          if (res.code == 0) {
            this.companyList = this.companyList.concat(res.data.content);
            this.companyTk = true;
            if (res.data.totalPages > this.page) {
              this.page += 1;
              this.getCompany();
            }
          } else {
            this.$toast({
              type: "fail",
              message: res.msg,
              className: "failLong",
              duration: 3000,
            });
          }
        });
    },
    getInfo() {
      serivce.post(`https://lingximind.com/mqtt/gateway/info`, { mac: this.gateway }).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          this.onlineHistoryList = res.data.onlineHistoryList;
          this.gatewayInfo = res.data.gateway;
          this.gatewayTk = true;
        } else {
          this.$toast({
            type: "fail",
            message: res.msg,
            className: "failLong",
            duration: 3000,
          });
        }
      });
    },
    getMac() {
      serivce
        .get(`https://lingximind.com/mqtt/gateway/braceletInfo`, { braceletMac: this.macNumber })
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data);
            this.macInfo = res.data;
            this.timer = setInterval(() => {
              clearInterval(this.timer)
              this.timer = null
              this.getMac();
            }, 3000);
          } else {
            this.$toast({
              type: "fail",
              message: res.msg,
              className: "failLong",
              duration: 3000,
            });
          }
        });
    },
    macCode() {
      const vm = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
          console.log(res);
          // alert(JSON.stringify(res))
          // var result = res.resultStr;
          vm.macNumber = res.resultStr;
      clearInterval(vm.timer);
          vm.getMac();
          vm.macTk = true;
        },
        error: function (res) {
          alert(JSON.stringify(res));
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
    companyCode() {
      const vm = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
          console.log(res);
          // alert(JSON.stringify(res))
          // var result = res.resultStr;
          vm.companyId = res.resultStr;
          vm.companyList = []
          vm.getCompany();
        },
        error: function (res) {
          // alert(JSON.stringify(res));
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
    watchCode() {
      const vm = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
          console.log(res);
          // alert(JSON.stringify(res))
          // var result = res.resultStr;
          vm.gateway = res.resultStr;
          vm.getInfo();
        },
        error: function (res) {
          alert(JSON.stringify(res));
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.scan {
  padding-top: 100px;
}
.companBtn {
  width: 80%;
  height: 0.8rem;
  line-height: 0.8rem;
  background: #1677ff;
  color: #fff;
  font-size: 0.3rem;
  margin: 0.4rem auto 0;
  text-align: center;
  border-radius: 0.1rem;
}
.companyTk {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  .main {
    background: #fff;
    position: relative;
    padding-bottom: 0.3rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.2rem;
    width: 6rem;
    overflow: hidden;
    box-sizing: border-box;
    img {
      position: absolute;
      right: 0.2rem;
      top: 0.1rem;
      width: 0.5rem;
    }
    .title {
      font-size: 0.32rem;
      padding: 0.3rem;
      color: #333;
      font-weight: bold;
      text-align: center;
    }
    .h3 {
      font-size: 0.28rem;
      font-weight: bold;
      margin: 0.2rem 0.3rem;
    }
    .listsTitle {
      display: flex;
      span {
        font-size: 0.24rem;
        flex: 1;
        text-align: center;
        line-height: 0.5rem;
        background: #f7f7f7;
      }
    }
    .info {
      p {
        font-size: 0.28rem;
        flex: 1;
        margin: 0;
        text-align: left;
        padding-left: 0.3rem;
        line-height: 0.5rem;
      }
    }
    .lists {
      max-height: 6rem;
      overflow-y: scroll;
      div {
        display: flex;
        border-bottom: 1px solid #f7f7f7;
        span {
          // line-height: 0.5rem;
          height: 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 0.2rem;
          flex: 1;
        }
        i {
          text-align: center;
          font-size: 0.2rem;
          line-height: 0.5rem;
          flex: 1;
          font-style: normal;
        }
      }
    }
  }
}
</style>